/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';


export const Option = ({ label, value }) => {
    return <option value={value}>{label}</option>
};

export const Select = ({ options, onChange, selected, sm, className }) => {
    const classes = `form-control ${sm ? "select-sm" : ""} ${className ? className : ""}`;

    return <select onChange={(e) => onChange(e.target.value)} className={classes} value={selected}>
        {options.map(option => <Option key={option.value} {...option}  />)}
    </select>
};

Select.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
    }))
};

Select.defaultProps = { options: [] };
